<template>
    
    <div class="bg-blue-900 h-full shadow-lg flex flex-col pt-20">

        <div class="flex-1">

            <div v-if="numOfVacRemain !== null" class="text-center text-white py-4">
                <div class="leading-tight text-4xl font-bold">{{ numOfVacRemain }}</div>
                <div class="leading-tight text-sm">vacation days<br>remaining (spent + planned)</div>
            </div>

            <div class="text-center my-4">
                <router-link :to="{ name: 'marktime-new'}" class="btn btn-secondary mr-2">
                    Create marktime &nbsp;&nbsp;&nbsp;&nbsp;<span class="font-normal">+</span>
                </router-link>
            </div>

            <div class="text-center mb-6">
                <router-link :to="{ name: 'vacation-new'}" replace class="btn btn-primary mr-2">
                    Vacation request &nbsp;&nbsp;&nbsp;&nbsp;<span class="font-normal">+</span>
                </router-link>
            </div>

            <router-link v-if="canAccess('canViewManagerDashboard')" :to="{ name: 'dashboard-manager'}" class="side-link flex items-center">
                <Zondicon icon="view-tile" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Dashboard</span>
            </router-link>
            
            <router-link v-if="canAccess('canViewAccounterDashboard')" :to="{ name: 'dashboard-accounter'}" class="side-link flex items-center">
                <Zondicon icon="view-tile" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Dashboard</span>
            </router-link>

            <router-link v-if="canAccess('canViewVacations')" :to="{ name: 'dashboard-vacations'}" class="side-link flex items-center">
                <Zondicon icon="view-tile" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Vacations</span>
            </router-link>

            <router-link :to="{ name: 'calendar'}" class="side-link flex items-center">
                <Zondicon icon="calendar" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Calendar</span>
            </router-link>

            <router-link :to="{ name: 'marktime-list'}" class="side-link flex items-center">
                <Zondicon icon="inbox" class="w-3 mr-5 fill-current" />
                <span class="text-sm">My marktimes</span>
            </router-link>

            <router-link v-if="$store.getters['user/isTeamLeader']" :to="{ name: 'teamleader-marktimes'}" class="side-link flex items-center">
                <Zondicon icon="user-group" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Team marktimes</span>
            </router-link>

            <router-link :to="{ name: 'vacation-list'}" class="side-link flex items-center">
                <Zondicon icon="news-paper" class="w-3 mr-5 fill-current" />
                <span class="text-sm">My vacations</span>
            </router-link>

            <router-link v-if="$store.getters['user/isTeamLeader']" :to="{ name: 'teamleader-vacations'}" class="side-link flex items-center">
                <Zondicon icon="user-group" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Team vacations</span>
            </router-link>            

            <router-link v-if="canAccess('canViewUsers')" :to="{ name: 'users'}" class="side-link flex items-center">
                <Zondicon icon="user-group" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Users</span>
            </router-link>

            <router-link v-if="canAccess('canViewPermissions')" :to="{ name: 'permissions'}" class="side-link flex items-center">
                <Zondicon icon="key" class="w-3 mr-5 fill-current" />
                <span class="text-sm">Permissions</span>
            </router-link>

        </div>

        <a href="#" @click.prevent="openDocumentation()" class="flex text-sm items-center text-gray-200 font-normal hover:text-gray-400 justify-center mb-4">
            <span>Documentation</span>
        </a>

        <a href="mailto:miroslav.maler@ezilly.cz" class="flex items-center text-gray-500 font-thin hover:text-white justify-center">
            <Zondicon icon="bug" class="w-4 mr-2 fill-current" />
            <span>Report a bug</span>
        </a>

        <AppVersion></AppVersion>

    </div>

</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { storage } from '../firebase';
import Zondicon from 'vue-zondicons'
import helper from '../helpers'

import AppVersion from '@/components/AppVersion.vue'

export default {

    computed: {
        ...mapState({
            currentUser: state => state.user.info,
            currentUserVacations: state => state.user.vacations,
        }),
        ...mapGetters({
            numOfVacDays: 'numOfVacDays'
        }),
        numOfVacRemain() {
            if (this.currentUser && this.currentUser.totalVacationsDays) {
                return this.currentUser.totalVacationsDays - this.numOfVacDays
            }
            return null
        }
    },

    components: {
      AppVersion,
      Zondicon
    },

    methods: {
        canAccess(type) {
            return helper.canAccess(type, this.currentUser)
        },

        async openDocumentation() {
            try {
                var file = await storage.refFromURL(`${process.env.VUE_APP_FIREBASE_STORAGE_DOMAIN}/documentation/marktime-prirucka-2021-10.pptx`).getDownloadURL();
                window.open(file);
            } catch(e) {
                this.$toasted.show(`Error: Cannot download file!`, {
					type: 'error'
				})
            }
        }
    },

    created() {
        if (!this.currentUserVacations) this.$store.dispatch('user/getVacations');
    }
}

</script>